import API from './'

const user = {

	/**
	 * Get a list of users.
	 */
	list(params={}, config={})
	{
		let url = API.getUrl(`users`)

		return API.client().get(url, { params, ...config })
	},

	/**
	 * Get one user details.
	 */
	one(userId, params={}, config={})
	{
		let url = API.getUrl(`user/${userId}`)

		return API.client().get(url, { params, ...config })
	},

	/**
	 * Get user notifications.
	 */
	notifications(params = {})
	{
		const url = API.getUrl(`notifications`)

		return API.client().get(url, params )
	},

	/**
	 * Mark notifications as read.
	 */
	markNotifications(ids=[], data={})
	{
		const url = API.getUrl('notifications/read')

		data.ids = ids

		return API.client().post(url, data)
	}

}

export default user